const useBlockReport = () => {
  const blockUser = (userId: string) => {
    return new Promise((resolve) => {
      FriendsDataManager.isBlocked(userId, (isBlocked: boolean) => {
        if (!isBlocked) {
          FriendsDataManager.setBlock(userId, true);
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  };

  const reportProfile = (userInfo: UserInfo) => {
    return new Promise((resolve) => {
      blockUser(userInfo.fbUid);
      sendProfileLog(userInfo);

      const photoUrl = userInfo.photo2.main;
      if (photoUrl?.startsWith('http')) {
        BUtil.digestMessage(
          photoUrl,
          (hash: string) => {
            BLog.log('[PhotoManager::getMainPhotoKey] url/hash=', photoUrl, hash);
            sendProfilePhoto(photoUrl, hash, userInfo.fbUid);
          },
          'SHA-1'
        );
        resolve(true);
      } else {
        sendProfilePhoto(photoUrl, photoUrl, userInfo.fbUid);
        resolve(true);
      }
    });
  };

  const sendProfilePhoto = (photo: string | undefined, key: string | undefined, fbUid: string) => {
    if (photo && key && fbUid) {
      SignalClient.mpush2('operation.feed.reported', { fbUid, value: key, filename: photo });
    } else {
      BLog.error('report obj is not complete.');
    }
  };

  const sendProfileLog = (userInfo: UserInfo) => {
    const baObj = {
      sender: {
        fbUid: myinfo.fbUid,
        country: myinfo.country,
        gender: myinfo.gender,
      },
      receiver: {
        fbUid: userInfo.fbUid,
        country: userInfo.country,
        gender: userInfo.gender,
      },
      reportType: 'profileImage',
    };

    ba('report', undefined, baObj);
    BTracker.sendBLog(
      'report',
      {
        sender: myinfo.fbUid,
        receiver: userInfo.fbUid,
        reportType: 'profileImage',
      },
      true
    );
  };

  return {
    blockUser,
    reportProfile,
  };
};

export default useBlockReport;
